/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL21haW4vYWRtaW4vbWFzdGVyZGF0YS9hZGRpdGlvbmFsLXNlcnZpY2VzLW1hc3Rlci9hZGRpdGlvbmFsLXNlcnZpY2VzLW1hc3Rlci5jb21wb25lbnQuc2NzcyJ9 */"];
export { styles as styles };
